export default {
  methods: {
    $_CMS_getFactoryName(item){
			let _text = "";
			let target = item
			while (target.organization !== null) {
					_text = (_text ? `${target.organization.name || "-"}/` : target.organization.name || "-") + _text;
					target = target.organization
			}
			_text += _text ? `/${item.name || "-"}` : item.name || "-";
			return _text;
    },
    $_CMS_getRules(fieldsValue, key) {
			if (fieldsValue.contact_way === key) {
				if (key === 'email') return 'required|email'
				if (key === 'tel') return 'required'
			} else if (fieldsValue.contact_way !== key) {
				return null
			}
    },
		$_CMS_getRulesErrorMessage(fieldsValue, key) {
			if (fieldsValue.contact_way === key) {
				if (!fieldsValue[key]) {
					if (key === "email") return '請填入聯絡信箱'
					if (key === "tel") return '請填入聯絡電話'
				}
			} else if (fieldsValue.contact_way !== key) {
				return null
			}
		},
		$_CMS_setArticleAndActPostData(rawArticleVersions, rawActVersionAlls) {
			const actVersionAlls = rawActVersionAlls
				? rawActVersionAlls.map(({id, act}) => ({
            act_id: act.id,
            act_version_id: id,
          }))
				: [];
			const articleVersions = rawArticleVersions
				? rawArticleVersions.map(article => {
						return {
              article_id: article.article.id,
							article_version_id: article.id,
							act_version_id: article.act_version
								? article.act_version.id
								: article.act_versions[article.act_versions.length -1].id,
						}
					})
				: [];
			return { actVersionAlls, articleVersions };
		},
    $_CMS_isDeepEqual(obj1, obj2) {
      // 如果同一個參考，直接回傳 true
      if (obj1 === obj2) return true;

      // 如果其中一個不是 object 或 null，直接比較值
      if (typeof obj1 !== "object" || obj1 === null ||
          typeof obj2 !== "object" || obj2 === null) {
        return obj1 == obj2;
      }

      // 比較 key
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length != keys2.length) return false;

      // 遞迴比較每個 key 的值
      for (let key of keys1) {
        if (!Object.prototype.hasOwnProperty.call(obj2, key)) return false;
        if (!this.$_CMS_isDeepEqual(obj1[key], obj2[key])) return false;
      }

      return true;
    },
  }
}